import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const reviews = [{
    name: 'Michael T.',
    location: 'Des Moines, IA to Dallas, TX',
    text: 'LynJones Logistics made shipping my John Deere tractor completely stress-free. The driver was professional, kept me updated, and the equipment arrived in perfect condition. Highly recommend their heavy haul services.'
  }, {
    name: 'Sarah Jenkins',
    location: 'Denver, CO to Phoenix, AZ',
    text: 'I was nervous about transporting our new excavator across state lines, but they handled everything flawlessly. No upfront payment gave me peace of mind, and the final price matched the quote exactly.'
  }, {
    name: 'David R.',
    location: 'Chicago, IL to Nashville, TN',
    text: "Best heavy haulers I've ever used. Fast quote, clear communication, and they handled the oversized permits for my bulldozer without a hitch. Will use them again for our next job site move."
  }];
  return <section className="py-20 bg-slate-50" data-id="element-308">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-309">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-310">
          <h2 className="text-3xl md:text-4xl font-black text-brand-navy mb-4" data-id="element-311">
            Trusted by Contractors & Farmers Nationwide
          </h2>
          <p className="text-lg text-slate-600" data-id="element-312">
            Don't just take our word for it. See what our customers say about
            our reliable heavy equipment shipping services.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-313">
          {reviews.map((review, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 relative" data-id="element-314">
              <div className="flex gap-1 mb-4" data-id="element-315">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-yellow-400 fill-yellow-400" data-id="element-316" />)}
              </div>
              <p className="text-slate-700 mb-6 italic leading-relaxed" data-id="element-317">
                "{review.text}"
              </p>
              <div data-id="element-318">
                <p className="font-bold text-brand-navy" data-id="element-319">{review.name}</p>
                <p className="text-sm text-slate-500" data-id="element-320">{review.location}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}